module.exports = __webpack_public_path__ + "img/notification.8ba51b98.svg";